var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.5 13C1.43442 13.0008 1.36941 12.9879 1.30913 12.962C1.24885 12.9362 1.19465 12.898 1.15 12.85C0.95 12.65 0.95 12.34 1.15 12.14L5.3 7.98999L1.15 3.84999C0.95 3.64999 0.95 3.33999 1.15 3.13999C1.35 2.93999 1.66 2.93999 1.86 3.13999L6.35 7.64999C6.55 7.84999 6.55 8.15999 6.35 8.35999L1.85 12.85C1.75 12.95 1.62 13 1.5 13Z"}));
}

ChevronRight.defaultProps = {"width":"7","height":"16","viewBox":"0 0 7 16","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
